import Resource from '../../../utils/resourcesUtil';

export function loginRequest(email, password, userNameType) {
  const deviceId = localStorage.getItem("deviceId");
  const headers = {
    deviceId: 'MY-SUNBIT-WEB-' + deviceId,
  };
  return Resource.postPci(
    'my-sunbit-service/api/v1/customer/login',
    { userName: email, password, userNameType },
    { headers }
  );
}

export function otpTypeLoginRequest(otpType, token) {
  const headers = {
    Authorization: `Bearer ${token}`
  };
  return Resource.postPci(
    'my-sunbit-service/api/v1/customer/login/otp/send',
    { otpType },
    { headers }
  );
}

export function verifyLoginOtp(verificationCode, otpType, token) {
  const deviceId = localStorage.getItem("deviceId");
  const headers = {
    Authorization: `Bearer ${token}`,
    deviceId: 'MY-SUNBIT-WEB-' + deviceId,
  };
  return Resource.postPci(
    'my-sunbit-service/api/v1/customer/login/otp/verify',
    {
      otpType,
      verificationCode,
    },
    { headers }
  );
}

export function loginWithRefreshToken(refreshToken) {
  return Resource.postPci('my-sunbit-service/api/v1/customer/login/refresh-token',
    {
      refreshToken
    }).then(
    result => result.data
  );
}

export function getCurrentUser(token) {
  return Resource.get('purchase-service/api/v1/customers/current', {headers: {Authorization: `Bearer ${token}`}}).then(
    result => result.data
  );
}



// WEBPACK FOOTER //
// ./src/actions/auth/authWithOtp/authApi2.js